import { formatJettons, formatTon } from '../lib/format';
import { Copy } from '../i18n';
import { LaunchPassportLine } from '../quotes/passport';

export function SeedDevBuyLines({
  lines,
  copy,
  ticker,
}: {
  lines: [LaunchPassportLine, LaunchPassportLine];
  copy: Copy;
  ticker?: string;
}) {
  const [seed, devBuy] = lines;
  return (
    <div className="group" data-testid="passport-lines">
      <div className="cell">
        <div>
          <div className="label">{copy.seedLine}</div>
          <div className="hint" style={{ margin: '4px 0 0' }}>
            {copy.seedLineHint}
          </div>
        </div>
        <div className="value" data-testid="seed-ton">
          {formatTon(seed.ton)}
          {seed.jettons > 0n ? (
            <div className="value muted">{formatJettons(seed.jettons, ticker)}</div>
          ) : null}
        </div>
      </div>
      <div className="cell">
        <div>
          <div className="label">{copy.devBuyLine}</div>
          <div className="hint" style={{ margin: '4px 0 0' }}>
            {copy.devBuyLineHint}
          </div>
        </div>
        <div className="value" data-testid="devbuy-ton">
          {formatTon(devBuy.ton)}
          {devBuy.jettons > 0n ? (
            <div className="value muted">{formatJettons(devBuy.jettons, ticker)}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
